"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var styles_1 = require("./styles");
var PageHeader = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, actions = _a.actions;
    var classes = (0, styles_1.useStyles)();
    return ((0, jsx_runtime_1.jsxs)("header", __assign({ role: "banner", className: classes.root }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.header }, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ component: "h1", variant: "h5", "data-testid": "page-header-title", className: classes.title }, { children: title })), subtitle && ((0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ component: "h2", variant: "subtitle1", "data-testid": "page-header-subtitle" }, { children: subtitle })))] })), actions && (0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": "page-header-actions" }, { children: actions }))] })));
};
exports.PageHeader = PageHeader;
